export default [
  {
    path: "/add-account",
    name: "addAccount",
    component: () =>
      import(/* webpackChunkName: "site" */ "./add-account.component.vue"),
  },
];
